import InlineInput from './InlineInput';

export default InlineInput;
